var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05b---Loan-Denied",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-156.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(160.000000, 208.000000)",
    fill: "#3989E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,56 C43.463973,56 56,43.463973 56,28 C56,12.536027 43.463973,0 28,0 C12.536027,0 0,12.536027 0,28 C0,43.463973 12.536027,56 28,56 Z M28,60 C10.326888,60 -4,45.673112 -4,28 C-4,10.326888 10.326888,-4 28,-4 C45.673112,-4 60,10.326888 60,28 C60,45.673112 45.673112,60 28,60 Z",
    id: "Oval-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2180961,42.9919444 C42.3251754,42.9919444 43.2222222,42.09052 43.2222222,40.9780382 L43.2222222,38.5613508 C43.2093958,33.3115002 39.0800943,29.0049632 33.8589449,28.7979336 C38.2343531,25.6079062 39.2083584,19.4574368 36.0338226,15.0606768 C32.8592868,10.6639168 26.7386855,9.68515843 22.3632773,12.8751858 C17.9878691,16.0652132 17.0146655,22.2148771 20.1883996,26.6124426 C20.7944474,27.4510332 21.5279576,28.189734 22.3632773,28.7979336 C17.139723,29.0049632 13.0096198,33.3163335 13,38.5694064 L13,40.9860938 C13,42.0985756 13.8978485,43 15.0041261,43 C16.1112054,43 17.0082523,42.0985756 17.0082523,40.9860938 L17.0082523,38.5694064 C17.0082523,35.3882402 19.5743354,32.8096347 22.7400531,32.8096347 C24.8876746,32.8104403 26.6288594,31.0615642 26.6296611,28.9042679 C26.6296611,27.6000622 25.9835308,26.3820518 24.9045093,25.65624 C22.2606661,23.8678913 21.5592219,20.2638048 23.3388859,17.6062542 C24.4459652,15.9524345 26.3210256,14.9857595 28.3043089,15.0469822 C31.4066961,15.1911779 33.8637548,17.7343386 33.9158621,20.8550877 C33.9222753,22.793271 32.9659063,24.6065921 31.365812,25.6884625 C29.5733215,26.8758616 29.0770999,29.2981879 30.2587327,31.1002312 C30.9802181,32.2006295 32.2035367,32.8611907 33.5150368,32.8579685 C36.6799528,32.8579685 39.246036,35.436574 39.246036,38.6177402 L39.246036,41.0344276 C39.2764987,42.1122702 40.1454878,42.9750276 41.2180961,42.9919444",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c6e1586aab683185f46a16ad58a5b967.svg";
export { ForwardRef as ReactComponent };